import { useField } from 'formik';

import { useGroups } from '@/react/portainer/environments/environment-groups/queries';
import { useCreateGroupMutation } from '@/react/portainer/environments/environment-groups/queries/useCreateGroupMutation';
import { EnvironmentGroupId } from '@/react/portainer/environments/types';
import { UNASSIGNED_GROUP_ID } from '@/react/portainer/environments/environment-groups/utils/getPlatformLabel';

import { FormControl } from '@@/form-components/FormControl';
import { PortainerSelect } from '@@/form-components/PortainerSelect';

interface Props {
  name?: string;
  allowCreate?: boolean;
}

export function GroupField({
  name = 'meta.groupId',
  allowCreate = false,
}: Props) {
  const [fieldProps, metaProps, helpers] = useField<EnvironmentGroupId>(name);

  const groupsQuery = useGroups();
  const createGroupMutation = useCreateGroupMutation();
  if (!groupsQuery.data) {
    return null;
  }

  const options = groupsQuery.data.map((group) => ({
    value: group.Id,
    label: group.Name,
  }));

  return (
    <FormControl
      label="Group"
      inputId="environment-group-selector"
      errors={metaProps.error}
    >
      <PortainerSelect<EnvironmentGroupId>
        inputId="environment-group-selector"
        name={name}
        data-cy="environment-group-select"
        options={options}
        value={fieldProps.value}
        onChange={(value) => helpers.setValue(value ?? UNASSIGNED_GROUP_ID)}
        isCreatable={allowCreate}
        onCreateOption={handleCreate}
        isLoading={createGroupMutation.isLoading}
        disabled={createGroupMutation.isLoading}
      />
    </FormControl>
  );

  function handleCreate(groupName: string) {
    createGroupMutation.mutate(
      { name: groupName },
      { onSuccess: (group) => helpers.setValue(group.Id) }
    );
  }
}
